import { APIS } from "../components/constants/app.constant";
import { getResource, postResource } from "./axiosService";

export const storeAuthToken = (token: string) => {
  localStorage.setItem("accessToken", token);
};
export const setUserLoggedIn = (isLoggedIn: string) => {
  localStorage.setItem("isUserLoggedIn", isLoggedIn);
};

export const loginService = () => {
  const apiUrl = APIS.LOGIN;
  return postResource(apiUrl);
};

export const getConfig = () => {
  const apiUrl = APIS.CONFIG;
  return getResource(apiUrl);
};
export function storeBusinessName(businessName: string) {
  localStorage.setItem("businessName", businessName);
}
export const logoutService = () => {
  const apiUrl = APIS.LOGOUT;
  return getResource(apiUrl);
};
export function clearAuthData() {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("isUserLoggedIn");
  localStorage.removeItem("businessName");
  localStorage.removeItem('expiryDate');
}
const getAccessTokenFromToken = () : string =>{
  const token = localStorage.getItem("accessToken");
  return token?.split('_')[1] ?? '';
}
export function appendTokenToHeader() {
  const tokenParam = "?token=" + getAccessTokenFromToken();
  const businessNameParam = "&name=" + localStorage.getItem("businessName");
  let url = window.location.pathname;
  url += tokenParam + businessNameParam;
  window.location.href = url;
}
